/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Enum_Master6Inputs */

const en_cv_extract_form_enum_master6 = /** @type {(inputs: Cv_Extract_Form_Enum_Master6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master`)
};

const de_cv_extract_form_enum_master6 = /** @type {(inputs: Cv_Extract_Form_Enum_Master6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master`)
};

/**
* | output |
* | --- |
* | "Master" |
*
* @param {Cv_Extract_Form_Enum_Master6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_enum_master6 = /** @type {((inputs?: Cv_Extract_Form_Enum_Master6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Enum_Master6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_enum_master6(inputs)
	return en_cv_extract_form_enum_master6(inputs)
});
export { cv_extract_form_enum_master6 as "cv_extract_form_enum_MASTER" }